// eslint-disable-next-line import/no-extraneous-dependencies
import { AxiosRequestConfig } from 'axios';
import { NuxtAxiosInstance } from 'vue/types/vue';
import axiosInstance from './request';
import { ResponseBase } from './base';

export interface ECommerceGoods {
    encryptItemId?: string;
    title?: string;
    imageUrl?: string;
    categoryId?: number;
    salePrice?: number;
    displaySalePrice?: string;
    saleCount?: number;
    displaySaleCount?: string;
    displayMaxPrice?: string;
    description?: string;
    detail?: string;
}

interface GetECommerceSearchListRequest {
    keyword?: string;
    /**
     * @zh 上一次获取数据的最后一个 encryptItemId
     */
    pcursor?: string;
    count?: number;
    fromUser?: boolean;
    needTdk?: boolean;
    needLdJson?: boolean;
    url?: string;
}

interface GetECommerceSearchListResponse extends ResponseBase {
    goods?: Array<ECommerceGoods>;
    ldJson?: Array<any>;
    tdk?: Array<any>;
}

class ECommerceApiService {
    private $axios?: NuxtAxiosInstance;

    constructor() {
        this.$axios = axiosInstance;
    }

    async getECommerceSearchList(data: GetECommerceSearchListRequest, config?: AxiosRequestConfig) {
        const res = await this.$axios?.$$post?.<GetECommerceSearchListResponse>('overseaAPI::/rest/o/w/pwa/v2/eshop/search', data, config);

        return res;
    }
}

export const ECommerceApi = new ECommerceApiService();
